class DetailsModal extends HTMLElement {
    constructor() {
        super();
        this.detailsContainer = this.querySelector('details');
        this.summaryToggle = this.querySelector('summary');

        if (this.detailsContainer) {
            this.detailsContainer.addEventListener(
                'keyup',
                (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
            );
        }

        if (this.summaryToggle) {
            this.summaryToggle.addEventListener(
                'click',
                this.onSummaryClick.bind(this)
            );
            this.summaryToggle.setAttribute('role', 'button');
            this.summaryToggle.setAttribute('aria-expanded', 'false');
        }

        /* KY_22.05 start */
        var closeHandler = this.close.bind(this);
        this.querySelectorAll('.search-modal__close-button, [data-bc-search-close]').forEach(function (closeButton) {
            closeButton.addEventListener('click', closeHandler);
        });
        /* KY_22.05 end */
    }

    isOpen() {
        return this.detailsContainer && this.detailsContainer.hasAttribute('open');
    }

    onSummaryClick(event) {
        event.preventDefault();

        if (!this.detailsContainer) return;
        event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
    }

    /* KY_22.05 start */
    onBodyClick(event) {
        if (this.summaryToggle && (this.summaryToggle === event.target || this.summaryToggle.contains(event.target))) {
            return;
        }
        var content = this.querySelector('.search-modal__content');
        if (content) {
            if (content.contains(event.target)) {
                return;
            }
        } else if (this.contains(event.target)) {
            return;
        }
        this.close(false);
    }
    /* KY_22.05 end */

    open(event) {
        if (!this.detailsContainer) return;
        this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
        event.target.closest('details').setAttribute('open', true);
        document.body.addEventListener('click', this.onBodyClickEvent);

        var contentNode = this.detailsContainer.querySelector('[tabindex="-1"]');
        var inputNode = this.detailsContainer.querySelector('input:not([type="hidden"])');
        try {
            if (contentNode && inputNode) {
                trapFocus(contentNode, inputNode);
            } else if (inputNode) {
                trapFocus(inputNode);
            } else if (contentNode) {
                trapFocus(contentNode);
            }
        } catch (e) {}
    }

    close(focusToggle = true) {
        removeTrapFocus(this.summaryToggle && focusToggle ? this.summaryToggle : null);
        if (this.detailsContainer) {
            this.detailsContainer.removeAttribute('open');
        }
        document.body.removeEventListener('click', this.onBodyClickEvent);
    }
}

if (!customElements.get('details-modal')) {
    customElements.define('details-modal', DetailsModal);
}
